import {
  ApiRoute,
  CreateUserProfile,
  ProfileDetail,
  ProfileDetailSchema,
  UpdateUserProfile,
  User,
  UserSchema,
  getApiRoute
} from "@garther/interfaces";

import { API_BASE_URL } from "../configs";
import { BaseApiClient } from "./base-client";

export class ProfileApiClient extends BaseApiClient {
  constructor() {
    super({
      baseURL: API_BASE_URL,
      baseEndpoint: getApiRoute(ApiRoute.PROFILE),
      requireAuth: true
    });
  }

  async getMyProfile(): Promise<ProfileDetail | null> {
    try {
      return await this.get("me", ProfileDetailSchema, { requireAuth: true });
    } catch (error) {
      return null;
    }
  }

  async getProfileByUserId(userId: string): Promise<ProfileDetail | null> {
    try {
      return await this.get(userId, ProfileDetailSchema, { requireAuth: false });
    } catch (error) {
      return null;
    }
  }

  // Convenience methods for current user (recommended)
  async createMyProfile(profileData: CreateUserProfile): Promise<User> {
    return await this.post("me", UserSchema, profileData, { requireAuth: true });
  }

  async updateMyProfile(updateData: UpdateUserProfile): Promise<ProfileDetail> {
    return await this.put("me", ProfileDetailSchema, updateData, { requireAuth: true });
  }

  // async deleteMyProfile(): Promise<void> {
  //   return await this.delete("me", z.void(), { requireAuth: true });
  // }
}

// Create and export the profile API client instance
export const profileApiClient = new ProfileApiClient();
